export default () => {
  return (
    typeof window !== 'undefined' &&
    typeof window.location !== 'undefined' &&
    typeof window.document !== 'undefined'
  );
};
